import * as constants from './constants';

export default {
    [constants.regionList](state, data) {
        state.regionList = data || [];
    },

    [constants.RegionInfos](state, data) {
        state.regionInfos = data || {};
    },

    [constants.QueryProductGroups](state, data) {
        state.priceSet = data || [];
    },

    [constants.Getlines](state, data) {
        state.LineSet = data.LineSet || [];
    },

    [constants.DescribeBandWidthShares](state, data) {
        state.BwsSet = data.BandWidthShareSet || [];
    },

    [constants.OSImageList](state, imageConfig) {
        state.osImages = imageConfig.images || [];
        state.pTypeConfig = imageConfig.p_type_config || [];
    },

    [constants.ImageList](state, imageSet) {
        state.imageSet = imageSet;
    },

    [constants.DedicatedList](state, data) {
        state.dedicatedList = data.DedicatedHostSet || [];
    },

    [constants.projList](state, data) {
        state.projList = _.get(data, 'ListProjectResult.ProjectList', []);
    },

    [constants.snapList](state, data) {
        state.snapList = _.get(data, 'LocalVolumeSnapshotSet', []);
        state.snapListTotal = _.get(data, 'LocalVolumeSnapshotCount', 0);
    },
    [constants.getEbsSnap](state, data) {
        state.snapList = _.get(data, 'LocalVolumeSnapshotSet', []);
        state.snapListTotal = _.get(data, 'LocalVolumeSnapshotCount', 0);
    },

    [constants.snapLessNum](state, data) {
        state.lessSnapNum = _.get(data, 'count', 0);
    },
    [constants.getDedicatedCluster](state, data) {
        state.clusterlist = data.DedicatedClustersSet;
    },
    // --以下为未登录mutations--
    [constants.noLoginGetlines](state, data) {
        state.LineSet = data.LineSet || [];
    },
    [constants.noLoginQueryProductGroups](state, data) {
        state.priceSet = data || [];
    },
    //--以上为未登录mutations--
};
